import React, { FC, PropsWithChildren } from "react";

import {
  NonPlayableVideoOverlay,
  NonPlayableVideoText
} from "./NonPlayableStyles";

export const NonPlayableContent: FC<PropsWithChildren> = ({ children }) => (
  <NonPlayableVideoOverlay>
    <NonPlayableVideoText>{children}</NonPlayableVideoText>
  </NonPlayableVideoOverlay>
);
